import React, { type ReactNode } from 'react';

import { cn } from '../lib/utils';

type Padding = 'none' | 'xs' | 'sm' | 'md' | 'lg';

const paddingMap: Record<Padding, string> = {
  none: '',
  xs: 'p-1.5',
  sm: 'p-2.5',
  md: 'p-4',
  lg: 'p-6'
};

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  className?: string;
  padding?: Padding;
}

function Card({ children, className, padding = 'md', ...rest }: CardProps) {
  return (
    <div
      {...rest}
      className={cn(
        'rounded-lg border border-uniform-gray-200 bg-white shadow-xs',
        'dark:border-uniform-gray-700 dark:bg-uniform-gray-900',
        paddingMap[padding],
        className
      )}>
      {children}
    </div>
  );
}

export { Card };
export type { CardProps };
